module.exports = __webpack_public_path__ + "media/images/image3-a85d20ff6f4a3f3c4c944da46ca12a91.png";